var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('main',[_c('section',[_c('div',{staticClass:"text-left pt-2 pl-4",staticStyle:{"font-size":"16px"}})])])
}]

export { render, staticRenderFns }